import axios from 'axios';
import type { BundleScanSubsetEntry } from '../schemas/apiResponse.schemas';
import {
  BundleScanSubsetAddResponseSchema,
  BundleScanSubsetListResponseSchema,
  BundleScanSubsetRemoveResponseSchema,
} from '../schemas/apiResponse.schemas';
import { validateResponse } from './validateResponse';

const API_BASE = '/api/bundle-scan-subset';

export async function fetchBundleScanSubset(): Promise<BundleScanSubsetEntry[]> {
  const response = await axios.get(API_BASE);
  const parsed = validateResponse(
    BundleScanSubsetListResponseSchema,
    response.data,
    'fetchBundleScanSubset'
  );
  return parsed.entries;
}

export async function addBundleScanSubsetParent(parentSku: string): Promise<BundleScanSubsetEntry> {
  const response = await axios.post(API_BASE, { parent_sku: String(parentSku).trim() });
  const parsed = validateResponse(
    BundleScanSubsetAddResponseSchema,
    response.data,
    'addBundleScanSubsetParent'
  );
  return parsed.entry;
}

export async function removeBundleScanSubsetParent(id: number): Promise<void> {
  const response = await axios.delete(`${API_BASE}/${id}`);
  validateResponse(
    BundleScanSubsetRemoveResponseSchema,
    response.data,
    'removeBundleScanSubsetParent'
  );
}
